import { useRef } from 'react';
import { YoutubeFrame } from 'components/iframe-youtube';
import styles from './styles.module.css';
import { Anchor } from 'constants/anchors';
import { Icon } from 'common/icon';
import clsx from 'clsx';

const VideoSlider = ({ videoLinks }: { videoLinks?: string[] }) => {
  const sliderRef = useRef<HTMLDivElement>(null);

  if (!videoLinks || !videoLinks.length) {
    return null;
  }

  const scrollLeft = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -400, behavior: 'smooth' });
    }
  };

  const scrollRight = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 400, behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.sliderWrapper}>
      <div id={Anchor.slot.bigWins} />
      <div className={styles.titleWrapper}>
        <div className={styles.title}>
          <Icon.Award />
          <div className={styles.titleText}>Big Wins</div>
        </div>
      </div>

      <div className={styles.sliderContainer}>
        <button
          className={clsx(styles.arrowLeft, styles.arrowLeftRotate)}
          onClick={scrollLeft}
        >
          <Icon.Arrow fill="#000" />
        </button>

        <div className={styles.slider} ref={sliderRef}>
          <div className={styles.videoList}>
            {videoLinks.map((videoId, index) => (
              <div key={index} className={styles.videoItem}>
                <YoutubeFrame
                  fullScreen
                  link={videoId}
                  width={180}
                  height={270}
                />
              </div>
            ))}
          </div>
        </div>

        <button className={styles.arrowRight} onClick={scrollRight}>
          <Icon.Arrow fill="#000" />
        </button>
      </div>
    </div>
  );
};

export default VideoSlider;
